import React, { useState } from 'react';
import { Button, intl, Maskable } from 'ehs-react';
import { PortletStoreApi } from '../App';

function AgreementPage({
  title,
  operation,
  onBackClicked
}: Readonly<{
  title: string;
  operation: string;
  onBackClicked: () => void;
}>): JSX.Element {
  const ref = React.useRef<HTMLIFrameElement>(null);
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const [iframeHeight, setIframeHeight] = useState('0px');
  const onLoad = () => {
    setIframeLoaded(true);
    setIframeHeight(
      ref?.current?.contentWindow?.document.body.scrollHeight + 'px'
    );
  };
  return (
    <div className="agreement-page">
      <div className="agreement-page-header">
        <div className="agreement-page-header-content">
          <div className="agreement-page-header-icon">
            <img
              src="/o/PatientSelfOnboardingPortlet/images/terms_header.png"
              role="none"
            />
          </div>
          <div className="agreement-page-header-text">
            <h1 className="font-18 center sh-font">{title}</h1>
          </div>
        </div>
      </div>
      <div className="agreement-page-content">
        <Maskable
          masked={!iframeLoaded}
          className="agreement-page-content-iframe-container"
        >
          <iframe
            ref={ref}
            onLoad={onLoad}
            src={PortletStoreApi.getState().url + '&operation=' + operation}
            height={iframeHeight}
            sandbox="allow-same-origin"
          />
        </Maskable>
        <div className="content-button-bar">
          <Button
            scale={'medium'}
            text={intl('patientSelfOnboardingPortlet.agreementPage.buttonBack')}
            variant="primary"
            onClick={() => onBackClicked()}
          />
        </div>
      </div>
    </div>
  );
}

export default AgreementPage;
